
import {
    INIT,
    RESET,
    SET_DIAS,
    SET_DISABLED,
    SET_TIPO_GESTION,
   
} from './types';

export const initialStateDisabled={
    "siniestro":{disabled:false, radio:true},
    "patente": {disabled:false, radio:true},
    "idcaso": {disabled:false, radio:true},
    "tipogestion": {disabled:false, radio:true},    
    "tarea": {disabled:false, radio:true},    
    "estadocaso": {disabled:false, radio:false},     
    "situacionsiniestro": {disabled:false, radio:false}, 
    "fechadesde": {disabled:false, radio:false},
    "fechahasta": {disabled:false, radio:false}, 
    "tipofecha": {disabled:false, radio:false}, 
    "declaracionpolicial": {disabled:false, radio:false}, 
    "intanciajudicial": {disabled:false, radio:false}, 
    "indlesionados": {disabled:false, radio:false},
    "asignagestion": {disabled:false, radio:true}, 
    "respuestacia": {disabled:false, radio:false}, 
    "motivorpta": {disabled:false, radio:false}
    
}

export default function buscarReducer(state , action) {
    switch (action.type) {
        case RESET:
            return { ...state,
                siniestro:{...state.siniestro, disabled:false},
                patente:{...state.patente, disabled:false},               
                tipogestion:{...state.tipogestion, disabled:false},
                tarea:{...state.tarea, disabled:false},
                estadocaso:{...state.estadocaso, disabled:false},
                idcaso:{...state.idcaso, disabled:false},
                situacionsiniestro:{...state.situacionsiniestro, disabled:false},
                fechadesde:{...state.fechadesde, disabled:false},
                fechahasta:{...state.fechahasta, disabled:false},
                tipofecha:{...state.tipofecha, disabled:false},
                declaracionpolicial:{...state.declaracionpolicial, disabled:false},
                intanciajudicial:{...state.intanciajudicial, disabled:false},
                indlesionados:{...state.indlesionados, disabled:false},
                asignagestion:{...state.asignagestion, disabled:true},
                respuestacia:{...state.respuestacia, disabled:true},
                motivorpta:{...state.motivorpta, disabled:true}        
               
                }
        case INIT:
            return { ...state,
                siniestro:{...state.siniestro, disabled:false},
                patente:{...state.patente, disabled:false},               
                tipogestion:{...state.tipogestion, disabled:true},
                tarea:{...state.tarea, disabled:false},
                estadocaso:{...state.estadocaso, disabled:false},               
                idcaso:{...state.idcaso, disabled:false},
                situacionsiniestro:{...state.situacionsiniestro, disabled:true},
                fechadesde:{...state.fechadesde, disabled:true},
                fechahasta:{...state.fechahasta, disabled:true},
                tipofecha:{...state.tipofecha, disabled:true},
                declaracionpolicial:{...state.declaracionpolicial, disabled:true},
                intanciajudicial:{...state.intanciajudicial, disabled:true},
                indlesionados:{...state.indlesionados, disabled:true},
                asignagestion:{...state.asignagestion, disabled:false},
                respuestacia:{...state.respuestacia, disabled:true},
                motivorpta:{...state.motivorpta, disabled:true}
                }
        case SET_DISABLED:
            action.payload.name

            return { ...state,[action.payload.name]:{...[action.payload.disabled], disabled:[action.payload.disabled]} }
        
       
        case SET_DIAS:
            return { ...state, dias:{...state.dias, disabled:action.payload}}                           
       
        default:
            return state
    }
}